const GLOBAL_KEY = "bystander_access_global";

export function setBystanderAccessToken(reportId, token) {
  if (!token) return;
  if (reportId) {
    sessionStorage.setItem(`bystander_access_${reportId}`, token);
  }
  sessionStorage.setItem(GLOBAL_KEY, token);
}

export function getBystanderAccessToken(reportId) {
  if (reportId) {
    const scoped = sessionStorage.getItem(`bystander_access_${reportId}`);
    if (scoped) return scoped;
  }
  return sessionStorage.getItem(GLOBAL_KEY) || "";
}

export function withBystanderAuth(config = {}, reportId) {
  const token = getBystanderAccessToken(reportId);
  if (!token) return config;
  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  };
}
